import React, { useEffect, useState } from 'react';
import { Typography, Row, Col, Button, Space, Card } from 'antd';
import { AppleOutlined, AndroidOutlined } from '@ant-design/icons';
import { getCurrentDestination } from '../services/destinationsService';

const { Title, Text } = Typography;

function AppDownload() {
  const [city, setCity] = useState(null);

  useEffect(() => {
    fetchCity();
  }, []);

  async function fetchCity() {
    const cityData = await getCurrentDestination();

    setCity(cityData);
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)',
      }}
    >
      <Card
        style={{
          maxWidth: 800,
          width: '100%',
          textAlign: 'center',
          borderRadius: 12,
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        }}
      >
        <Text style={{ fontSize: 18, marginBottom: 48, display: 'block' }}>
          Explore your city like never before with our mobile app. Get instant access to local
          events, places, and guided tours.
        </Text>

        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={12}>
            <Button
              type="primary"
              size="large"
              icon={<AppleOutlined />}
              href={city?.apple_store || '#'}
              target="_blank"
              disabled={!city?.apple_store}
              style={{
                height: 60,
                width: '100%',
                fontSize: 18,
                backgroundColor: '#000',
                borderColor: '#000',
              }}
            >
              App Store {city?.apple_store ? '' : '(Coming Soon)'}
            </Button>
          </Col>
          <Col xs={24} sm={12}>
            <Button
              type="primary"
              size="large"
              icon={<AndroidOutlined />}
              href={city?.google_play || '#'}
              disabled={!city?.google_play}
              target="_blank"
              style={{
                height: 60,
                width: '100%',
                fontSize: 18,
                backgroundColor: '#689f38',
                borderColor: '#689f38',
              }}
            >
              Google Play {city?.google_play ? '' : '(Coming Soon)'}
            </Button>
          </Col>
        </Row>

        <div style={{ marginTop: 48 }}>
          <Space direction="vertical" size="large">
            <div>
              <Row gutter={[16, 16]} style={{ textAlign: 'left' }}>
                <Col xs={24} md={8}>
                  <Title level={4}>Discover Places</Title>
                  <Text>Find interesting locations and hidden gems around the city.</Text>
                </Col>
                <Col xs={24} md={8}>
                  <Title level={4}>Local Events</Title>
                  <Text>Stay updated with the latest events and activities.</Text>
                </Col>
                <Col xs={24} md={8}>
                  <Title level={4}>Guided Tours</Title>
                  <Text>Experience the city with curated guided tours.</Text>
                </Col>
              </Row>
            </div>
          </Space>
        </div>
      </Card>
    </div>
  );
}

export default AppDownload;
